import { anatomyModule } from "./anatomy";
import { cranialnervesModule } from "./cranialnerves";
import { lobesModule } from "./lobes";
import { neuronsModule } from "./neurons";
import { physiologyModule } from "./physiology";

export const brainModules = [
  anatomyModule,
  lobesModule,
  neuronsModule,
  cranialnervesModule,
  physiologyModule,
];
